export const compareAlphabetically = (a: string | undefined, b: string | undefined) => {
  const upperA = a?.toUpperCase();
  const upperB = b?.toUpperCase();
  if (upperA && upperB) {
    if (upperA < upperB) {
      return -1;
    }
    if (upperA > upperB) {
      return 1;
    }
  }
  return 0;
};
